import React, { Component } from "react";
import { Field } from "formik";
import RadioField from "../fields/RadioField";
import ConditionalComponent from "../ConditionalComponent";
import { injectIntl } from "react-intl";

class FieldsRaquet extends Component {
  render() {
    const { intl } = this.props;
    return (
      <>
        <ConditionalComponent conditions={{ minX: 27 }}>
          <Field
            name="net"
            component={RadioField}
            label={intl.formatMessage({
              id: "raquet.tennisNet",
              defaultMessage: "Siatka do tenisa",
            })}
          />
        </ConditionalComponent>
        <ConditionalComponent conditions={{ maxX: 27 }}>
          <Field
            name="volleyballNet"
            component={RadioField}
            label={intl.formatMessage({
              id: "raquet.volleyballNet",
              defaultMessage: "Siatka do siatkówki",
            })}
          />
        </ConditionalComponent>
      </>
    );
  }
}

export default injectIntl(FieldsRaquet);
